import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { FiChevronDown, FiChevronUp } from 'react-icons/fi';
import TeamSection from './TeamSection';
import './ClubSection.css';

const ClubSection = ({ clubName, teamsData }) => {
  const navigate = useNavigate();
  const [isExpanded, setIsExpanded] = useState(clubName === '12 Stars CC');

  const teams = Object.keys(teamsData).sort();

  const handleClubClick = (e) => {
    if (e.target.closest('.club-badge')) {
      e.stopPropagation();
      navigate(`/club/${encodeURIComponent(clubName)}`);
    } else {
      setIsExpanded(!isExpanded);
    }
  };

  return (
    <div className="club-section">
      <div 
        className="club-header"
        onClick={handleClubClick}
      >
        <div className="club-header-content">
          {isExpanded ? <FiChevronUp /> : <FiChevronDown />}
          <h2 className="club-name">{clubName}</h2>
          <span className="club-badge">{teams.length} Teams</span>
        </div>
      </div>

      {isExpanded && (
        <div className="club-body">
          {teams.map((team) => (
            <TeamSection
              key={team}
              teamName={team}
              yearsData={teamsData[team]}
            />
          ))}
        </div>
      )}
    </div>
  );
};

export default ClubSection;
